import CommonAppbar from '../components/common/CommonAppbar';
import * as React from 'react';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import {getCoinsIcon} from '../components/common/simpleComponents';

const COINS_PRICE = [{
  price: 10,
  coins: 100,
}, {
  price: 50,
  coins: 600,
}, {
  price: 100,
  coins: 1500,
}, {
  price: 500,
  coins: 8000,
}, {
  price: 1000,
  coins: 20000,
}]
export default function BuyCoins() {
  return <>
    <CommonAppbar isMainPage={false} pageHeader={'Buy coins'}/>
    <Box sx={{backgroundColor: 'lightgrey', pt: 1}}>
      {COINS_PRICE.map(coinPrice => {
        return <Card sx={{m: 1}}>
          <CardContent>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <div>Buy {getCoinsIcon()} {coinPrice.coins} coins {' '}</div>
              <div><Button variant="contained">₹{coinPrice.price} </Button></div>
            </Stack>
          </CardContent>
        </Card>
      })}
    </Box>
  </>
}
